/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import { LinkContainer } from './styles';

const ShareButton = ({ className, link, text, icon, target, disabled }) => (
    <LinkContainer className={className} href={link} target={target} rel="noopener noreferrer" disabled={disabled}>
        {icon}
        {text}
    </LinkContainer>
);

ShareButton.propTypes = {
    className: PropTypes.string,
    link: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    icon: PropTypes.node,
    target: PropTypes.string,
    disabled: PropTypes.bool,
};

ShareButton.defaultProps = {
    className: '',
    link: '#',
    text: '',
    icon: null,
    target: '_blank',
    disabled: false,
};

export default ShareButton;
